// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3klQh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__1dZFQ"};